import React from 'react';
import { BarChart2, Activity, Calendar, Sparkles, Newspaper, CheckSquare } from 'lucide-react';
import { AnalyticsWidget } from './AnalyticsWidget';
import { ActivityWidget } from './ActivityWidget';
import { CalendarWidget } from './CalendarWidget';
import { WelcomeWidget } from './WelcomeWidget';
import { NewsWidget } from './NewsWidget';
import { TasksWidget } from './TasksWidget';
import { InteractiveCalendarWidget } from './InteractiveCalendarWidget';
import type { WidgetDefinition } from '../../../types/dashboard';

export const widgetDefinitions: WidgetDefinition[] = [
  {
    type: 'welcome',
    title: 'Welcome',
    description: 'Your personal dashboard overview',
    icon: <Sparkles className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 2,
      h: 2,
      minW: 2,
      minH: 2,
    },
    component: WelcomeWidget,
  },
  {
    type: 'analytics',
    title: 'Analytics Overview',
    description: 'Display key metrics and trends',
    icon: <BarChart2 className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 2,
      h: 2,
      minW: 2,
      minH: 2,
    },
    component: AnalyticsWidget,
  },
  {
    type: 'activity',
    title: 'Recent Activity',
    description: 'Track latest updates and notifications',
    icon: <Activity className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 1,
      h: 2,
      minW: 1,
      minH: 2,
    },
    component: ActivityWidget,
  },
  {
    type: 'calendar',
    title: 'Calendar',
    description: 'View upcoming events and schedules',
    icon: <Calendar className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 1,
      h: 2,
      minW: 1,
      minH: 1,
    },
    component: CalendarWidget,
  },
  {
    type: 'news',
    title: 'Latest News',
    description: 'Stay updated with the latest announcements',
    icon: <Newspaper className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 1,
      h: 2,
      minW: 1,
      minH: 2,
    },
    component: NewsWidget,
  },
  {
    type: 'tasks',
    title: 'My Tasks',
    description: 'Manage your personal tasks',
    icon: <CheckSquare className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 1,
      h: 2,
      minW: 1,
      minH: 2,
    },
    component: TasksWidget,
  },
  {
    type: 'interactive-calendar',
    title: 'Interactive Calendar',
    description: 'Plan and manage your events',
    icon: <Calendar className="h-6 w-6 text-indigo-600" />,
    defaultLayout: {
      w: 2,
      h: 2,
      minW: 2,
      minH: 2,
    },
    component: InteractiveCalendarWidget,
  },
];